<template>
  <div>
    <ModalBase :show-modal="showModal" :auto-h="true" :narrow="true" @close-modal="close">
      <template v-slot:titlebar>
        <TitleBar variant-class="title-modal">
          <template v-slot:title>
            {{ $gettext('New project') }}
          </template>
        </TitleBar>
      </template>
      <template v-slot:maincontent>
        <AddProjectSimple ref="addeditproject" @created="onProjectCreated" />
      </template>
      <template v-slot:actions>
        <GekkoButton 
          @click="$refs.addeditproject.saveForm()"
          :text="$gettext('Save')"
          icon="fa-solid fa-floppy-disk"
          type="submit"
          class="float-right"
        />
      </template>
    </ModalBase>
  </div>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import AddProjectSimple from "@/components/contacts/AddProjectSimple"
import GekkoButton from "@/components/GekkoButton";

export default {
  name: "ProjectModalSimple",
  components: { ModalBase, TitleBar, AddProjectSimple, GekkoButton },

  data() {
    return {
      showModal: true
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
  },
  methods: {
    close(){
      // console.log('cancel')
      this.$emit('cancel')
      this.closeModal()
    },
    onProjectCreated(val) {
      this.$emit('created', val)
      this.closeModal()
    },
    closeModal () {
      this.showModal = false
      document.body.classList.remove('modal-on')
      this.$emit('cancel')
    },
    initializeProjectDetails() {
      this.projectDetails = {
        company: null,
        name: "",
        contact_name: null,
        reference: "",
        description: "",
        hourly_rate: null,
        favorite: false,
      }
    }
  }
};
</script>

<style lang="scss">

</style>
